
<div class="leaderboard-tab-inner leaderboard-tab-inner1">
	<div class="headerFixed">
		<div class="setting-box-header">
			<input type="text" #searchText class="serach-box" placeholder="{{bs.getResource('rbkey_SrchLBL')}}" (keyup.enter)="search(searchText.value)">
			<a href="javascript:void(0);" class="icon-magnifier-panel" (click)="search(searchText.value)" >
				<i class="fa fa-search"></i>
			</a>
		</div>
		
	<!-- <div class="container"> -->	
		<div class="row">
			<div class="panel panel-default">
				<div class="panel-heading">
					<h5 class="h5-1">
						{{bs.getResource('rbkey_BlckdLBL')}}
					</h5>
					<div class="dCheckbox">
						<h5 class="h5-1">
							{{bs.getResource('rbkey_SlctAllLBL')}}
						</h5>
						 &nbsp;
						<input type="checkbox" style="opacity: 1" (change)="toggleSelectAll($event)">
					</div>
				</div>
				<app-loader *ngIf="loader"></app-loader>
				<table class="table table-fixed">
					<thead>
						<tr>
							<th class="col-xs-2">{{bs.getResource('rbkey_LgnIdLBL')}}</th>
							<th class="col-xs-4">{{bs.getResource('rbkey_brfc_NmLbl')}}</th>
							<th class="col-xs-2">{{bs.getResource('rbkey_EmlAdrsLBL')}}</th>
							<th class="col-xs-2">{{bs.getResource('rbkey_JbRlLBL')}}</th>
							<th class="col-xs-2">{{bs.getResource('rbkey_ChckTUnhdLBL')}}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let uObj of userList" class="row">
							<td class="col-xs-2 uData">{{uObj['UserLogOnCode']}}</td>
							<td class="col-xs-4 uData">{{uObj['UserName']}}</td>
							<td class="col-xs-2 uData">{{uObj['UserEmail']}}</td>
							<td class="col-xs-2 uData">{{uObj['JobRole']}}</td>
							<td class="col-xs-2">
								<input id="{{uObj['UserId']}}" style="opacity: 1" value="{{uObj['UserId']}}" name="Users" type="checkbox">
							</td>
						</tr>

					</tbody>
				</table>
				<!-- <a class="share-btn" style="margin-left: 10px; margin-top:10px;" href="javascript:void(0);" (click)="saveList()">{{bs.getResource('rbkey_UsrSvChngsBTN')}}</a>
				<a class="share-btn" style="margin-top:10px;"  href="javascript:void(0);" (click)="showHideList()">{{bs.getResource('rbkey_HdUsrsLBL')}}</a> -->
			</div>
		</div>
	<!-- //	</div> -->
	</div>
</div>